/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CSpecialLink {
    WHATS_APP = 'WhatsApp',
    TELEGRAM = 'Telegram',
}
